<template>
    <tab-layout>
        <!-- <template slot="title">
            {{ $l10n.__('Statistiques') }}
        </template> -->

        <template slot="content">
            <div class="flex-level mb-3">
                <h2 class="m-0">
                    {{ $l10n.__("Statistiques") }}
                </h2>
                <div class="flex-level flex-item-right">
                    <select-input 
                        class="dinlineb mr-3"
                        mode="edit" 
                        v-model="period"
                        :options="periods"
                        @input="fetchStat"
                    />
                    <select-input 
                        v-if="currencies.length > 1"
                        class="dinlineb"
                        mode="edit" 
                        v-model="currency"
                        :options="currencies"
                        :filterable="true"
                        labelColumn="name"
                        idColumn="id"
                        @input="fetchStat"
                    />
                </div>
            </div>
            <div class="prelative">
                <preloader :display="loading" class="mt-5"/>
            </div>
            <div v-if="!loading" class="flex-level fw-wrap" style="align-items:baseline;">
                <div v-for="(card, indexCard) in cardFormatted" :key="indexCard" class="stat-card no-shrink well p-0">
                    <component :is="card.component" :data="card"/>
                </div>
            </div>
        </template>
    </tab-layout>
</template>

<script>
    import StatDefaultCard from '../../statistics/StatDefaultCard.vue'
    import StatSecondaryCard from '../../statistics/StatSecondaryCard.vue'
    import StatListCard from '../../statistics/StatListCard.vue'
    import StatisticCards from './mapping/StatisticCards'
    import { mapGetters } from 'vuex'
    import { dateInterval, periods } from '../../../helpers'
    import Preloader from "vcomponents/utilities/Preloader.vue";
    import SelectInput from 'vcomponents/inputs/SelectInput.vue';
    import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

    export default {
        props: [],
        data(){
            return {
                period: 'all',
                currency: '1',
                allCards: StatisticCards,
                cardFormatted: [],
                cards: [],
                filters: {},
                loading: true
            }
        },
        created(){
            if(localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_period`) !== null){
                this.period = localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_period`)
            }
            if(localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_currency`) !== null){
                this.currency = localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_currency`)
            } else{
                if(this.currencies.length >= 1){
                    this.currency = this.currencies[0].id
                }
            }
            this.fetchStat()
        },
        computed: {
            periods(){
                return periods
            },
            ...mapGetters({
                availableStatCards : 'availableStatCards', 
                linkedid : 'linkedid',
                linkedtype : 'linkedtype',
                currencies : 'currencies',
            }),
        },
        methods: {
            fetchStat(){
                this.loading = true
                this.buildFilters()
                this.cards = []
                this.cardFormatted = []
                let routeStat = this.$router.resolve({name: 'overview.statistics', params: {linkedtype: this.linkedtype, linkedid: this.linkedid}})
                this.$ajax.get(routeStat.href, this.filters,
                (response) => {
                    this.cards = response
                    this.mergeValues()
                    this.saveFilters()
                    this.loading = false
                },
                (error) => {
                    Push.error(this.$l10n.__('Une erreur est survenue lors de la récupération des statistiques.', false))
                })

            },
            mergeValues(){
                this.cards.map(cardValue => {
                    if(this.availableStatCards.includes(cardValue.name)){
                        let cardLabels = this.allCards.find(card => card.card == cardValue.name)
                        if(cardLabels){
                            cardValue = {...cardValue, ...{title: cardLabels.title, component: cardLabels.component}}
                            if(cardValue.slots && cardValue.slots.length > 0){
                                cardValue.slots.map((slot, index) => {
                                    if(cardLabels.labels[slot.name]){
                                        let hasNumberInTitle = cardValue.slots[index].slots.find(number => number.type == 'nb')?.value
                                        cardValue.slots[index] = {...slot, ...{label : cardLabels.labels[slot.name].title(hasNumberInTitle ? hasNumberInTitle : null)}}
                                        if(slot.slots && slot.slots.length > 0){
                                            slot.slots.reverse()
                                            slot.slots.map((subSlot, indexSub) => {
                                                cardValue.slots[index].slots[indexSub] = {...subSlot, ...{label: cardLabels.labels[slot.name][subSlot.type]}}
                                            })
                                        }
                                    }
                                })
                            }
                            this.cardFormatted.push(cardValue)
                        }
                    }
                })
            },
            saveFilters(){
                localStorage.setItem(`ov_stat_${this.linkedtype}_${this.linkedid}_period`, this.period)
                localStorage.setItem(`ov_stat_${this.linkedtype}_${this.linkedid}_currency`, this.currency)
            },
            buildFilters(){
                let interval = dateInterval(this.period, moment())
                this.filters.datestart = interval.start
                this.filters.dateend = interval.end
                this.filters.cards = this.availableStatCards
                this.filters.currency = this.currency
            },
        },
        components: {
            StatDefaultCard,
            StatSecondaryCard,
            StatListCard,
            Preloader,
            'select-input': SelectInput,
            TabLayout,
        }
    }
</script>

<style scoped lang="scss">
    .stat-card {
        width : calc(50% - 16px);
        margin-bottom : 32px;
    
        &:nth-child(even)   { margin-left: 16px; }
        &:nth-child(odd)    { margin-right: 16px; }
    }
</style>